import React, { useState } from "react";
import RegistrationLabels from "/components/pop-ups/RegistrationLabels";
import { useTranslation } from "react-i18next";
import GiftBox from "/assets/img/promotion/starter-bag-lg.png";
import { NavLink } from "react-router-dom";
import styles from "./Registration.module.scss";
import WalletAuth from "/components/pop-ups/wallet-auth/WalletAuth";
import SocialButtonsGrid from "/components/pop-ups/Registration/SocialButtonsGrid";
import CustomButton from "/components/core/ButtonDefault";
import store from "/redux/state";
import { Web3Provider } from "/context/Web3Provider";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { SSOAdditionalForm } from "./ssoAdditionalForm";
import { useSSO } from "/utils/hooks/useSSO";

const tabs = [
  {
    title: "password",
    Component: RegistrationLabels,
  },
  // Controlled by feature flags below
  {
    title: "wallet",
    Component: () => (
      <Web3Provider>
        <WalletAuth />
      </Web3Provider>
    ),
  },
];

export default function Registration({ state, data: { tab }, defaultError }) {
  const isWalletConnectActive = useFeatureIsOn("can-use-auth-with-wallet");
  const isSocialLoginEnabled = useFeatureIsOn("social-register");
  const { t } = useTranslation();
  const availableTabs = [tabs[0], ...(isWalletConnectActive ? [tabs[1]] : [])];
  const [currentTab, setCurrentTab] = useState(() => {
    const requested = availableTabs.find((entry) => entry.title === tab)?.title;
    return requested || availableTabs[0]?.title || "password";
  });
  const { error, loading, signUp } = useSSO();

  const err = error ?? defaultError;

  return (
    <>
      <div className={`title ${styles.title}`}>
        <img src={GiftBox} alt="Claim Gift Box" className={styles.image} />
        <h2 className="t fixel_36">{t("message.welcomeToFuntico")}</h2>
      </div>

      {isSocialLoginEnabled ? (
        <>
          <div className={styles.tabs}>
            <SocialButtonsGrid
              disabled={loading}
              selected={currentTab}
              displayContext="registration"
              onSelect={(provider) => setCurrentTab(provider)}
            >
              {err && (
                <div className="text-center color-red">{err.message}</div>
              )}

              <SSOAdditionalForm
                handleSubmit={async (formValues) => {
                  await signUp(currentTab, formValues);
                  if (!error) {
                    state.setPopUp("");
                  }
                }}
                selectedProvider={currentTab}
                isMutating={loading}
              />
            </SocialButtonsGrid>
          </div>

          <div className="or df ai-c">{t("labels.orWith")}</div>
        </>
      ) : null}

      {availableTabs.length > 1 ? (
        <TabList
          tabs={availableTabs}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        >
          <TabContent>
            {availableTabs
              .filter(({ title }) => title === currentTab)
              .map(({ Component, title }) => (
                <Component key={title} />
              ))}
          </TabContent>
        </TabList>
      ) : (
        (() => {
          const FirstComp = availableTabs[0]?.Component;
          return FirstComp ? <FirstComp /> : <RegistrationLabels />;
        })()
      )}

      <div className="switch_form jc-c fw as-c df">
        <p className="fixel_16_sbl">{t("registration.alreadyHaveAccount")}</p>
        <button className="def wt" onClick={(e) => store.setPopUp("login")}>
          {t("registration.signInNow")}
        </button>
      </div>
    </>
  );
}

function TabList({ tabs, currentTab, setCurrentTab, children }) {
  const { t } = useTranslation();
  return (
    <div className={styles.tabs} role="tablist">
      <div className={`${styles.tabs_buttons} br-8`}>
        {tabs?.map(({ title }) => (
          <CustomButton
            key={title}
            role="tab"
            aria-selected={currentTab === title}
            classname={`grey ${currentTab === title ? styles.active : ""} ${
              styles.tab
            }`}
            title={t(`registration.tabs.${title}`)}
            def={24}
            onClick={() => setCurrentTab(title)}
          />
        ))}
      </div>
      {children}
    </div>
  );
}

function TabContent({ children }) {
  return <div className="content_data df fd-c">{children}</div>;
}
